module.exports = "/images/c048e07278c4267ef6d55dadec47d870.svg";